<template>
    <div class="app-container">
        <div class="filter-head">
            <div class="filter-item">
                <el-input v-model="listQuery.order_id" placeholder="订单号" clearable />
            </div>
            <div class="filter-item">
                <el-input v-model="listQuery.product_name" placeholder="产品名称" clearable />
            </div>
            <div class="filter-item">
                <el-select v-model="listQuery.type" placeholder="测评类型" clearable @change="onChangeType"
                    @clear="onClearType">
                    <el-option label="产品体验" :value="1" />
                    <el-option label="探店体验" :value="2" />
                </el-select>
            </div>
            <div class="filter-item">
                <el-select :loading="classifyLoading" v-model="listQuery.evaluation_class_id" placeholder="分类" clearable
                    :disabled="!listQuery.type">
                    <el-option v-for="item in classifyList" :key="item.id" :label="item.name" :value="item.id" />
                </el-select>
            </div>
            <div class="filter-item">
                <el-select v-model="listQuery.state" placeholder="状态" clearable>
                    <el-option label="申请中" :value="0" />
                    <el-option label="申请失败" :value="-1" />
                    <el-option label="申请成功" :value="1" />
                    <el-option label="已发货" :value="2" />
                    <el-option label="待提交问卷" :value="3" />
                    <el-option label="已完成" :value="4" />
                    <el-option label="已关闭" :value="5" />
                    <el-option label="已取消" :value="6" />
                    <el-option label="选择我不去了" :value="7" />
                    <el-option label="待发放积分" :value="8" />
                </el-select>
            </div>

            <div class="filter-item">
                <el-button icon="el-icon-search" :loading="listLoading" type="primary" @click="handleFilter">查询</el-button>
                <el-button type="warning" :loading="listLoading" icon="el-icon-upload2"
                    @click="exportExcel">导出Excel</el-button>
            </div>
        </div>

        <div class="table">
            <el-table v-loading="listLoading" element-loading-text="Loading" height="70vh" :data="tableData" border fit
                highlight-current-row>
                <el-table-column type="index" label="序号" width="85" align="center" />
                <el-table-column prop="order_id" label="订单号" min-width="110" align="center" />
                <el-table-column prop="user_info.name" label="用户名" min-width="110" align="center" />
                <el-table-column prop="evaluation.name" label="产品名称" min-width="110" align="center" />
                <el-table-column label="产品图片" min-width="150" align="center">
                    <template slot-scope="scope">
                        <img style="width:150px; height: 150px;" :src="scope.row.evaluation.cover_img_vertical" alt="商品图">
                    </template>
                </el-table-column>

                <el-table-column prop="state" label="状态" min-width="150" align="center">
                    <template slot-scope="scope">
                        <el-tag v-if="scope.row.state === 0" type="warning">申请中</el-tag>
                        <el-tag v-else-if="scope.row.state === -1" type="danger">申请失败</el-tag>
                        <el-tag v-else-if="scope.row.state === 1" type="success">申请成功</el-tag>
                        <el-tag v-else-if="scope.row.state === 2">已发货</el-tag>
                        <el-tag v-else-if="scope.row.state === 3" type="warning">待提交问卷</el-tag>
                        <el-tag v-else-if="scope.row.state === 4" type="success">已完成</el-tag>
                        <el-tag v-else-if="scope.row.state === 5" type="info">已关闭</el-tag>
                        <el-tag v-else-if="scope.row.state === 6" type="info">已取消</el-tag>
                        <el-tag v-else-if="scope.row.state === 7" type="info">选择我不去了</el-tag>
                        <el-tag v-else-if="scope.row.state === 8" type="info">待发放积分</el-tag>
                        <el-tag v-else type="info">后端无字段</el-tag>
                    </template>
                </el-table-column>

                <el-table-column prop="evaluation.merchant_info.name" label="商家" min-width="110" align="center" />
                <el-table-column prop="evaluation.type" label="测评类型" min-width="110" align="center">
                    <template slot-scope="scope">
                        <el-tag v-if="scope.row.evaluation.type === 1">产品体验</el-tag>
                        <el-tag v-else-if="scope.row.evaluation.type === 2">探店体验</el-tag>
                        <el-tag v-else>后端无字段</el-tag>
                    </template>
                </el-table-column>
                <el-table-column prop="evaluation.evaluation_class_info.name" label="分类" min-width="110" align="center" />


                <!-- <el-table-column prop="created_at" label="提交时间" min-width="110" align="center" /> -->
                <el-table-column prop="application_number" label="申请次数" min-width="95" align="center" />
                <el-table-column label="操作" width="200" align="center" fixed="right">
                    <div style="margin: -3px;" slot-scope="scope">
                        <el-button style="margin: 3px;" size="mini" @click="checkOrderDetail(scope.row)">订单详情</el-button>
                        <el-button style="margin: 3px;" v-if="scope.row.evaluation.type === 1" size="mini"
                            @click="checkAddress(scope.row.user_address_log)">查看地址</el-button>
                        <el-button style="margin: 3px;" v-if="scope.row.questionnaire_log" size="mini"
                            @click="checkUserQuestionnaire(scope.row)">查看问卷</el-button>
                        <el-button v-if="scope.row.state === -1" type="primary" size="mini" style="margin: 3px;"
                            @click="onRePass(scope.row.order_id)">修改审核</el-button>
                        <template v-if="scope.row.evaluation.type !== 2">
                            <el-button v-if="scope.row.state === 1 && scope.row.evaluation.type === 1 && scope.row.is_agree"
                                type="primary" style="margin: 3px;" size="mini"
                                @click="onShowLogisticModal(scope.row.order_id)">发货</el-button>
                            <el-button v-else-if="scope.row.state === 2" type="primary" style="margin: 3px;" size="mini"
                                @click="onSignature(scope.row.order_id)">签收</el-button>
                        </template>
                        <el-button style="margin: 3px;" size="mini" v-if="is_grant_integral === 1 && scope.row.state === 8"
                            @click="sendIntegral(scope.row, '发放积分')">发放积分</el-button>
                        <el-button style="margin: 3px;" size="mini" type="danger"
                            v-if="scope.row.state >= 1 && scope.row.state <= 3 && scope.row.is_agree === 1 &&
                             (scope.row.recommends_state === null || (scope.row.recommends_state >= 1 && scope.row.recommends_state <= 3))"
                            @click="closeOrder(scope.row, '关闭订单')">关闭订单</el-button>
                    </div>
                </el-table-column>
            </el-table>

            <div class="pagination-container">
                <el-pagination :current-page="listQuery.page" :page-sizes="[10, 20, 30, 50]" :page-size="listQuery.limit"
                    :total="total" background layout="total, sizes, prev, pager, next, jumper"
                    @size-change="handleSizeChange" @current-change="handleCurrentChange" />
            </div>
        </div>

        <CheckAddressModal v-if="addressVisible" :show.sync="addressVisible" :addressData="modalData" />
        <OrderDetailModal v-if="orderDetailVisible" :show.sync="orderDetailVisible" :detailData="modalData"
            @onUpdate="onTableActionModalSubmit" />
        <QuestionnaireDetailModal v-if="questionnaireVisible" :show.sync="questionnaireVisible" :detailData="modalData" />
        <LogisticModal v-if="logisticVisible" :show.sync="logisticVisible" :order_id="modalData"
            @onUpdate="onTableActionModalSubmit" />
    </div>
</template>

<script>
import CheckAddressModal from "./components/CheckAddressModal.vue"
import OrderDetailModal from "./components/OrderDetailModal.vue"
import QuestionnaireDetailModal from "./components/QuestionnaireDetailModal.vue"
import LogisticModal from "./components/LogisticModal.vue"
import { questionnaire } from "@/api/order"
import { review } from "@/api/review"
import store from '@/store'
import * as XLSX from "xlsx"

export default {
    data: () => ({
        is_grant_integral: '',
        listLoading: false,
        tableData: [],
        total: null,
        listQuery: {
            page: 1,
            limit: 10,
            type: null,
            order_id: '',
            product_name: '',
            evaluation_class_id: null,
            state: null
        },
        classifyLoading: false,
        classifyList: [],
        // 拟态
        orderDetailVisible: false,
        addressVisible: false,
        questionnaireVisible: false,
        logisticVisible: false,
        modalData: null,
    }),
    components: {
        CheckAddressModal,
        OrderDetailModal,
        QuestionnaireDetailModal,
        LogisticModal
    },
    methods: {
        // 关闭订单
        async closeOrder(value, title) {
            this.$confirm(`此操作将关闭订单, 是否继续?`, "提示", {
                confirmButtonText: "确定",
                cancelButtonText: "取消",
                type: "warning"
            }).then(async () => {
                await questionnaire.closeOrderServer({ order_id: value.order_id });
                this.$message({
                    message: "已关闭订单！",
                    type: "success",
                });
                this.getList();
            })
        },
        async sendIntegral(data, title) {
            this.$confirm(`此操作将发放积分, 是否继续?`, "提示", {
                confirmButtonText: "确定",
                cancelButtonText: "取消",
                type: "warning"
            }).then(async () => {
                await questionnaire.integral(data.order_id);
                this.$message({
                    message: "已发放积分！",
                    type: "success",
                });
                this.getList();
            })

        },
        async getList() {
            this.listLoading = true;
            this.tableData = []
            const { data } = await questionnaire.list(this.listQuery);
            this.tableData = data.data;
            this.total = data.total;
            this.listLoading = false;
        },
        async onChangeType(type) {
            this.listQuery.evaluation_class_id = null
            this.classifyLoading = true
            const { data } = await review.classify(type)
            this.classifyList = data
            this.classifyLoading = false
        },
        handleFilter() {
            this.listQuery.page = 1
            this.getList()
        },
        onClearType() {
            this.listQuery.evaluation_class_id = null
        },
        handleSizeChange(val) {
            this.listQuery.limit = val;
            this.getList()
        },
        handleCurrentChange(val) {
            this.listQuery.page = val;
            this.getList()
        },
        checkOrderDetail(data) {
            this.modalData = data
            this.orderDetailVisible = true
        },
        checkAddress(data) {
            this.modalData = data
            this.addressVisible = true
        },
        checkUserQuestionnaire(data) {
            this.modalData = data
            this.questionnaireVisible = true
        },
        onShowLogisticModal(id) {
            this.modalData = id
            this.logisticVisible = true
        },
        onSignature(id) {
            this.$confirm('此操作将确认签收, 是否继续?', '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning',
                center: true
            }).then(async () => {
                try {
                    await questionnaire.signature(id)
                    this.$message({
                        type: 'success',
                        message: '已确认签收!'
                    });
                    this.getList()
                } catch {
                    this.$message.error('出错了!');
                }
            }).catch(() => {
                this.$message('签收取消!');
            });
        },
        onRePass(order_id) {
            this.$confirm('此操作将通过审核, 是否继续?', '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning',
                center: true
            }).then(async () => {
                try {
                    await questionnaire.applicationPass(order_id)
                    this.$message({
                        type: 'success',
                        message: '已通过审核!'
                    });
                    this.getList()
                } catch {
                    this.$message.error('出错了!');
                }
            }).catch(() => {
                this.$message('审核取消!');
            });
        },
        onTableActionModalSubmit() {
            this.getList()
        },
        // 导出Excel
        async exportExcel() {
            console.log('exportExcel')

            const { total } = this
            if (!total) return

            try {
                const { data: { data: reqData } } = await questionnaire.list({ ...this.listQuery, page: 1, limit: total })
                console.log(reqData);

                var wb = XLSX.utils.book_new();

                var excelData = [
                    ['订单号', '用户名', '产品名称', '商家', '测评类型', '分类', '提交时间', "申请次数", '状态'],
                    ...reqData.map((item) => {
                        if (item.user_info) {
                            return [
                                item.order_id,
                                item.user_info.name,
                                item.evaluation.name,
                                item.evaluation.merchant_info.name,
                                item.evaluation.type === 1 ? '产品体验' : item.evaluation.type === 2 ? '探店体验' : '无字段',
                                item.evaluation.evaluation_class_info.name,
                                item.created_at,
                                item.application_number, // 申请次数
                                item.state === 0 ? '申请中' : item.state === -1 ? '申请失败' : item.state === 1 ? '申请成功' : item.state === 2 ? '已发货' : item.state === 3 ? '待提交问卷' : item.state === 4 ? '已完成' : item.state === 5 ? '已关闭' : item.state === 6 ? '已取消' : item.state === 7 ? '选择我不去了' : '无字段'
                            ]
                        }
                    })
                ];
                var ws = XLSX.utils.aoa_to_sheet(excelData);
                XLSX.utils.book_append_sheet(wb, ws, "调查问卷");
                XLSX.writeFile(wb, "订单列表-调查问卷.xlsx");

                this.$notify.info({
                    title: '消息',
                    message: '请等待, 正在生成Excel表格文件...'
                });
            } catch {
                this.$notify.error({
                    title: '错误',
                    message: '获取数据错误!'
                });
            }
        },
    },
    created() {
        this.getList()
        this.is_grant_integral = store.getters.is_grant_integral
    }
}
</script>

<style lang="scss" scoped>
.filter-head {
    display: flex;
    flex-wrap: wrap;
    margin: -5px;

    &>.filter-item {
        margin: 5px;
    }
}

.table {
    margin-top: 10px;

    .table-operations {
        margin-bottom: 10px;
    }
}
</style>
